export default __webpack_public_path__ + "static/media/Icons__error.26f8bc18.svg";